<template>
  <q-layout view="hHh lpR fFf" style="display: grid">
    <q-page-container :style="$q.screen.width < 485 ? `` : `margin: auto`">
      <q-card flat bordered :class="$q.screen.width < 485 ? `my-card-mobile` : `my-card`">
        <q-card-section>
          <div class="row justify-center">
            <q-img basic v-if="$q.screen.width < 485" contain width="50px"
              :src="require('@/assets/logo-villa-mobile.svg')" />
            <q-img basic v-else contain width="100px" :src="require('@/assets/logo-villa-mobile.svg')" />
          </div>
          <div class="row justify-center">
            <div class="text-h6">Villa market</div>
          </div>
        </q-card-section>

        <!-- <q-separator inset /> -->
        <template v-if="sessionExpire">
          <q-card-section :style="$q.screen.width < 485 ? `min-height: 75vh` : `min-height: 100px`
            ">
            <div class="row justify-center">
              <div class="text-h6">Session expired</div>
            </div>
          </q-card-section>
        </template>
        <template v-else-if="isRequestToPayError">
          <q-card-section :style="$q.screen.width < 485 ? `min-height: 75vh` : `min-height: 100px`
            ">
            <div class="row justify-center">
              <div class="" style="
                  display: flex;
                  flex-direction: column;
                  justify-content: center;
                  text-align: center;
                ">
                <div class="text-h6">Something went wrong</div>
                <p>Please try again later.</p>
              </div>
            </div>
          </q-card-section>
        </template>
        <template v-else-if="loading">
          <q-card-section>
            <div class="row justify-center">
              <q-spinner size="lg" color="primary" />
            </div>
          </q-card-section>
        </template>
        <template v-else>
          <q-card-section>
            <div class="text-subtitle2">Order {{ order.orderId }}</div>
            <div class="text-subtitle2">Shipping to</div>
            <div class="text-subtitle2 no-bold text-grey-8">
              {{ formatedAddress }}
            </div>
            <div class="text-subtitle2">Order summary</div>
            <div class="text-subtitle2 row justify-between no-bold" v-for="(product, index) in order.productList"
              :key="index">
              <div class="text-grey-8">
                {{ product.productName }} x{{ product.quantity }}
              </div>
              <div class="text-primary">฿ {{ product.price }}</div>
            </div>
          </q-card-section>

          <q-card-section>
            <div class="row full-width justify-between">
              <div class="text-subtitle2 no-bold">Sub total</div>
              <div class="text-subtitle2 no-bold">
                {{ order.subTotal }}
              </div>
            </div>
            <div v-if="order.deliveryFee > 0" class="row full-width justify-between">
              <div class="text-subtitle2 no-bold">Total delivery fee</div>
              <div class="text-subtitle2 no-bold">
                {{ order.deliveryFee | positiveNumber }}
              </div>
            </div>
            <div v-if="order.expressShippingCost > 0" class="row full-width justify-between">
              <div class="text-subtitle2 no-bold">Express fee</div>
              <div class="text-subtitle2 no-bold">
                {{ order.expressShippingCost | positiveNumber }}
              </div>
            </div>
            <div v-if="order.totalDiscount > 0" class="q-my-xs">
              <div v-if="order.totalDiscount > 0" class="row full-width justify-between">
                <div class="text-subtitle2 no-bold">Total discount</div>
                <div class="text-subtitle2 no-bold text-red">
                  {{ order.totalDiscount | nagativeNumber }}
                </div>
              </div>
              <div v-if="promotionalDiscount > 0" class="row full-width justify-between q-px-md text-grey-8">
                <div class="text-caption no-bold">Promotional discount</div>
                <div class="text-caption no-bold text-red">
                  {{ promotionalDiscount | nagativeNumber }}
                </div>
              </div>
              <div v-if="order.voucherDiscount > 0" class="row full-width justify-between q-px-md text-grey-8">
                <div class="text-caption no-bold">Voucher discount</div>
                <div class="text-caption no-bold text-red">
                  {{ order.voucherDiscount | nagativeNumber }}
                </div>
              </div>
            </div>
            <div class="row full-width justify-between">
              <div class="text-subtitle1 text-primary">Total</div>
              <div class="text-subtitle1 text-primary">
                ฿ {{ order.grandTotal }}
              </div>
            </div>
          </q-card-section>

          <q-separator inset />

          <q-card-section>
            <div class="text-h5">Choose payment method</div>
            <q-list bordered separator>
              <q-item dense tag="label" v-for="(item, index) in paymentMethods" :key="index" clickable v-ripple>
                <q-item-section avatar>
                  <q-radio v-model="selectedPaymentMethod" :val="item.value" />
                </q-item-section>
                <q-item-section>
                  <q-item-label>
                    <div style="display:flex; justify-content: space-between; align-items: center; width: 100%;">
                      <div style="white-space: nowrap;">{{ item.title }}</div>
                      <div
                        style="display:flex; justify-content: end; align-items: center; gap:8px; max-width: 300px; height: 32px; overflow:hidden;">
                        <img style="height: 28px !important;" v-for="logo in item.img" :key="logo"
                          :src="require(`@/assets/payment/${logo}`)" fit="contain" />
                      </div>
                    </div>
                  </q-item-label>
                </q-item-section>
              </q-item>
            </q-list>
          </q-card-section>

          <q-separator inset />

          <q-card-section>
            <q-btn unelevated no-caps no-wrap :loading="paymentLoading" class="full-width" block color="primary"
              label="Continue" @click="onContinue">
              <template v-if="loading" v-slot:loading>
                <q-spinner class="on-left" />
              </template>
            </q-btn>
          </q-card-section>
        </template>

        <q-card-section>
          <span class="text-subtitle2">
            <a href="https://shop.villamarket.com/terms">
              Terms and conditions
            </a>
            and
            <a href="https://shop.villamarket.com/privacy-policy">
              Privacy Policy
            </a>
          </span>
        </q-card-section>
      </q-card>
    </q-page-container>
    <component ref="payment" :is="paymentComponents[selectedPaymentMethod]" />
    <div style="display:none" ref="k-payment-form-container">
    </div>
  </q-layout>
  <!-- <div class="vplus-info" v-if="selectedPaymentMethod === `Vplus Wallet`">
          <q-card-section>
            <div class="text-h5">VPlus Wallet</div>
            <div class="column">
              <q-input
                dense
                square
                outlined
                label="Phone number"
                v-model="vplusData.phoneNumber"
                type="number"
                :maxlength="10"
                error-message="Please enter VPlus phone number."
                :error="!isValidPhone"
              ></q-input>
              <q-input
                dense
                square
                outlined
                :maxlength="6"
                label="Member ID"
                v-model="vplusData.memberId"
                error-message="Please enter VPlus member ID."
                :error="!isValidID"
              ></q-input>
            </div>
          </q-card-section>

          <q-separator inset />
        </div>

        <q-card-section>
          <q-btn
            unelevated
            no-caps
            no-wrap
            :loading="loading"
            class="full-width"
            block
            color="primary"
            label="Continue"
            @click="onContinue"
          >
            <template v-if="loading" v-slot:loading>
              <q-spinner class="on-left" />
            </template>
          </q-btn>
        </q-card-section>

        <q-card-section>
          <span class="text-subtitle2">
            <a href="https://shop.villamarket.com/terms">
              Terms and conditions
            </a>
            and
            <a href="https://shop.villamarket.com/privacy-policy">
              Privacy Policy
            </a>
          </span>
        </q-card-section>
      </q-card>
    </q-page-container>
    <q-dialog persistent v-model="dialogVplusWallet.show">
      <DialogAlert
        :message="dialogVplusWallet.message"
        :submessage="dialogVplusWallet.submessage"
        right-btn="Close"
        @rightClick="onCloseDialogVplusWallet"
      >
      </DialogAlert>
    </q-dialog>
    <component ref="payment" :is="paymentComponents[selectedPaymentMethod]" />
  </q-layout> -->
</template>

<script>
// import { mapGetters } from "vuex";
// import axios from "axios";
import API from "@aws-amplify/api";
// import Auth from "@aws-amplify/auth";
import PayVplus from "@/ui/components/PayVplus.vue";
import * as Sentry from "@sentry/browser";
import QRWalletPaymentDialog from "@/ui/pages/payment/QRWalletPaymentDialog.vue";

const paymentComponents = {
  "Credit/Debit card": "CreditCardForm",
  Amex: "CreditCardForm",
  Other: "CreditCardForm",
  "Vplus Wallet": "RequestToPayForm",
};

export default {
  name: "Pay",
  components: {
    CreditCardForm: () => import("@/ui/components/CreditCardForm.vue"),
    RequestToPayForm: () => import("@/ui/components/RequestToPayForm.vue"),
  },
  data() {
    return {
      sessionExpire: false,
      loading: true,
      isRequestToPayError: false,
      paymentLoading: false,
      memberId: null,
      phone: null,
      paymentComponents,
      paymentMethods: [
        {
          title: "Credit/Debit card",
          value: "Credit/Debit card",
          img: ["master-card.svg","visa.svg", "jcb.svg", "union.svg"]
        },
        // {
        //   title: "Vplus Wallet",
        //   value: "Vplus Wallet",
        //   img: ["wallet-logo.png"]
        // },
        {
          title: "Thai QR",
          value: "Thai QR",
          img: ["thai_qr.png"]
        },
        // {
        //   title: "WeChat Pay",
        //   value: "WeChat Pay",
        //   img: ["wechat-pay.png"]
        // },
        // {
        //   title: "Alipay",
        //   value: "Alipay",
        //   img: ["alipay_logo.jpg"]
        // },
        // {
        //   title: "American Express",
        //   value: "AmexV2",
        //   img: ["amex.svg"]
        // },
        {
          title: "American Express",
          value: "Amex",
          img: ["amex.svg"]
        },
      ],
      selectedPaymentMethod: null,
      order: {
        orderId: "123",
        shipping: {
          address: "168/22 mo. 5 Prakret Nonthaburi 11120",
        },
        productList: [
          {
            productName: "Turkey",
            price: 199,
            quantity: 3,
          },
          {
            productName: "Crushed Olives Naples Style",
            price: 140,
            quantity: 1,
          },
          {
            productName: "Spicy Red Snow Crab Paste",
            price: 129,
            quantity: 1,
          },
        ],
        deliveryFee: 60,
        discount: 0,
        subTotal: 866,
        total: 926,
      },
      promotionalDiscount: 0,
      saleId: null
    };
  },
  computed: {
    // ...mapGetters({
    //     loading: "order/loading",
    // }),
    shippingAddress() {
      return this.order.shipping;
    },
    formatedAddress() {
      if (this.shippingAddress) {
        const shippingAddress = this.shippingAddress;
        return `${shippingAddress.shippingAddress} ${shippingAddress.shippingSubDistrict || ""
          } ${shippingAddress.shippingDistrict || ""} ${shippingAddress.shippingProvince
          } ${shippingAddress.shippingPostcode}`;
      }
      return "";
    },
    RTP() {
      return this.$route.params.id;
    },
    // order() {
    //   return {
    //     shipping: {
    //       address: "168/22 mo. 5 Prakret Nonthaburi 11120",
    //     },
    //     productList: [
    //       {
    //         productName: "Turkey",
    //         price: 199,
    //         quantity: 3,
    //       },
    //       {
    //         productName: "Crushed Olives Naples Style",
    //         price: 140,
    //         quantity: 1,
    //       },
    //       {
    //         productName: "Spicy Red Snow Crab Paste",
    //         price: 129,
    //         quantity: 1,
    //       },
    //     ],
    //     deliveryFee: 60,
    //     discount: 0,
    //     subTotal: 866,
    //     total: 926,
    //   };
    // },
  },
  watch: {
    selectedPaymentMethod: {
      immediate: false,
      handler(value) {
        if (value === "Amex") {
          this.$store.dispatch("order/configureAmex");
        } else if (value === "AmexV2") {
          this.$store.dispatch("order/configureAmexV2");
        }
      },
    },
  },
  mounted() {
    console.log(this.$q.platform);
    console.log("get rtp", this.RTP);
    this.loadRequestToPay();
  },
  methods: {
    async loadRequestToPay() {
      let rtp;

      try {
        rtp = await this.$services.requestToPay.getRequestToPay(this.RTP);
        console.log({ rtp });

        if (rtp == null || rtp == undefined) {
          this.sessionExpire = true;
          return;
        }

        // get current time
        const response = await API.get("saletoolapi", "/time");

        if (response["time"] > rtp.expirationTime) {
          console.log("session expire");
          this.sessionExpire = true;
          return;
        }

        this.saleId = rtp.saleID;

        // await this.$services.authentication.getIdToken();
        let order = await this.$services.orders.getOrderById(rtp.orderID, "");

        console.log({ order });
        if (order.payment) {
          if (order.payment.isPaid == true) {
            console.log("session expire");
            this.sessionExpire = true;
            return;
          }
        }

        const apikey = await this.$services.authentication.getApikey();
        order = await this.$services.calculatePrice.getResolveCoupon(
          order,
          apikey.key
        );

        console.log({ order });

        this.order = order;
        this.order.orderId = rtp.orderID;

        this.promotionalDiscount =
          (order.bogoDiscount || 0) + (order.cartDiscount || 0);

        this.loading = false;
        // throw Error("Test loadRequestToPay error");
      } catch (error) {
        console.error(error);
        Sentry.captureException(error);
        this.isRequestToPayError = true;
        this.loading = false;
        return;
      }
    },
    async onContinue() {
      console.log("onContinue");
      const orderId = this.order.orderId;
      switch (this.selectedPaymentMethod) {
        case "Credit/Debit card":
          {
            window.location.href = `/pay2/${this.RTP}/card`;
          }
          break;
        case "Amex":
          {
            try {
              this.paymentLoading = true;
              console.log("pay by Amex");
              console.log(paymentComponents[this.selectedPaymentMethod]);
              const response = await this.$store.dispatch(
                "order/payByAmex",
                orderId
              );
              console.log(response);
              if (window.Checkout) {
                window.Checkout.configure({
                  session: {
                    id: response.session.id,
                  },
                  interaction: {
                    merchant: {
                      name: response.merchant, //required
                    },
                  },
                });
                window.Checkout.showPaymentPage();
              } else {
                throw new Error("Cannot connect AMEX");
              }

              setTimeout(() => {
                this.paymentLoading = false;
              }, 3000);
            } catch (error) {
              console.warn(error);
              this.paymentLoading = false;
            }
          }
          break;
        case "AmexV2":
          {
            try {
              this.paymentLoading = true;
              console.log("pay by AmexV2");
              console.log(paymentComponents[this.selectedPaymentMethod]);
              const response = await this.$store.dispatch(
                "order/payByAmexV2",
                { orderId, amount: this.order.grandTotal }
              );
              console.log(response);
              if (window.Checkout) {
                window.Checkout.configure({
                  session: {
                    id: response.session.id,
                  }
                });
                window.Checkout.showPaymentPage();
              } else {
                throw new Error("Cannot connect AMEX");
              }

              setTimeout(() => {
                this.paymentLoading = false;
              }, 3000);
            } catch (error) {
              console.warn(error);
              this.paymentLoading = false;
            }
          }
          break;
        case "Vplus Wallet":
          {
            console.log("pay by Vplus Wallet");

            this.$q.dialog({
              persistent: true,
              component: QRWalletPaymentDialog,
              orderId: this.order.orderId,
              amount: this.order.grandTotal,
              currency: this.order.currency,
              saleId: this.saleId,
            });


            // this.$q
            //   .dialog({
            //     // title: "Place order success",
            //     // message: `Order: ${order.orderId}`,
            //     cancel: true,
            //     persistent: true,
            //     component: PayVplus,
            //     store: this.$store,
            //     orderId,
            //     vmemberId: this.memberId,
            //     vphone: this.phone,
            //     // props forwarded to your custom component
            //     // parent: {
            //     // text: rtp.id,
            //     // ...more..props...
            //     // },
            //   })
            //   .onOk(async ({ phone }) => {
            //     console.log("OK");
            //     try {
            //       this.paymentLoading = true;

            //       //   this.memberId = memberId;
            //       this.phone = phone;

            //       const payload = {
            //         orderId,
            //         mobile: phone,
            //       };
            //       const response = await this.$store.dispatch(
            //         "order/payByWallet",
            //         payload
            //       );

            //       console.log({ response });

            //       if (response.statusCode == "00") {
            //         // this.$q.dialog({
            //         //   title: "Vplus Wallet",
            //         //   message: `Request to pay will be sent soon.`,
            //         // });
            //         const formRef = this.$refs["payment"];
            //         const { data } = response;
            //         console.log("formRef", formRef);
            //         formRef.setInfo(data);
            //         formRef.submit();
            //       } else {
            //         this.$q.dialog({
            //           title: "Error",
            //           message: response.message,
            //         });
            //       }

            //       this.paymentLoading = false;
            //     } catch (error) {
            //       console.warn(error);
            //       this.paymentLoading = false;
            //     }

            //     // clear cart
            //     // this.$store.dispatch("cart/clearBasket");
            //   })
            //   .onCancel(() => {
            //     // console.log('Cancel')
            //   })
            //   .onDismiss(() => {
            //     // console.log('I am triggered on both OK and Cancel')
            //   });
          }
          break;
        case "Thai QR": {
          window.location.href = `/pay2/${this.RTP}/qr?type=thaiqr`;
        }
          break;

        case "WeChat Pay": {
          window.location.href = `/pay2/${this.RTP}/qr?type=wechatpay`;
        }
          break;
      }
    }
  },
  async createQrPayment(type) {
    try {
      const apikey = await this.$services.authentication.getApikey();
      console.log("token", apikey);

      const result = await this.$services.pay.createKBankQrPayment(
        this.order.orderId,
        type,
        this.order.grandTotal,
        apikey.key,
      );

      console.log("create qr payment", result);
      return result;
    } catch (error) {
      console.error("create qr payment", error);
      Sentry.captureException(error);
      throw new Error("create qr payment error");
    }
  },
  onCloseDialogVplusWallet() {
    this.dialogVplusWallet.show = !this.dialogVplusWallet.show;
    this.dialogVplusWallet.message = undefined;
    this.dialogVplusWallet.submessage = undefined;
  },
  async processKBankCreditCardPaymentDev(order) {
    try {
      this.paymentLoading = true;

      await this.completelyRemoveKPayment();

      const containerRef = this.$refs["k-payment-form-container"];

      // Create form element
      const form = document.createElement("form");
      form.method = "POST";

      // add orderid
      const orderIdInput = document.createElement("input");
      orderIdInput.type = "hidden";
      orderIdInput.name = "orderId";
      orderIdInput.value = order.orderId;
      form.appendChild(orderIdInput);

      // add amount 
      const amountInput = document.createElement("input");
      amountInput.type = "hidden";
      amountInput.name = "amount";
      amountInput.value = this.order.grandTotal;
      form.appendChild(amountInput);

      // add authorization to headers
      const apikey = await this.$services.authentication.getApikey();
      console.log("token", apikey);

      const authInput = document.createElement("input");
      authInput.type = "hidden";
      authInput.name = "Authorization";
      authInput.value = apikey.key;
      form.appendChild(authInput);

      form.action =
        "https://kibxkqpe7d.execute-api.ap-southeast-1.amazonaws.com/production/api/v1/payment/credit-card";

      // Create script element
      const script = document.createElement("script");
      script.type = "text/javascript";
      script.async = true;
      script.src =
        "https://kpaymentgateway.kasikornbank.com/ui/v2/kpayment.min.js";
      script.setAttribute(
        "data-apikey",
        "pkey_prod_11069UdTmr16AeGHYvqmiD9AFiNJqNLg3lNDT"
      );
      script.setAttribute("data-amount", order.grandTotal);
      script.setAttribute("data-currency", "THB");
      script.setAttribute("data-payment-methods", "card");
      script.setAttribute("data-name", "Villa Market JP");
      script.setAttribute("data-mid", "401012226078001");
      script.setAttribute(
        "data-customer-id",
        order.ownerId
      );

      // Append script to form
      form.appendChild(script);

      // Append form to container
      containerRef.appendChild(form);

      return new Promise((resolve) => {
        script.onload = async () => {
          console.log("script loaded");
          await window.KPayment.create();
          window.KPayment.show();

          const paymentContainer = document.querySelector("div.payment-container[_kpayment]");
          console.log("paymentContainer class list", paymentContainer.classList);

          const wait = async (ms) => new Promise((r) => setTimeout(r, ms));
          await wait(500);

          // check if class 'show' is not present
          if (paymentContainer && paymentContainer.classList.contains("show")) {
            return resolve();
          }

          await wait(500);

          // check if class 'show' is not present
          if (paymentContainer && !paymentContainer.classList.contains("show")) {
            paymentContainer.classList.add("show");
          }

          resolve();
        };
      });
    } catch (error) {
      console.error("processKBankCreditCardPaymentDev error", error);
      Sentry.captureException(error);
      throw new Error("processKBankCreditCardPaymentDev error");
    } finally {
      this.paymentLoading = false;
    }
  },
  removeOldPaymentContent() {
    const containerRef = this.$refs["k-payment-form-container"];

    // Remove the script from the window
    const existingScript = document.querySelector('script[src="https://kpaymentgateway.kasikornbank.com/ui/v2/kpayment.min.js"]');
    if (existingScript) {
      existingScript.remove();
    }

    // Clear previous content
    while (containerRef.firstChild) {
      containerRef.removeChild(containerRef.firstChild);
    }

    // remove all payment-container
    const paymentContainer = document.querySelector("div.payment-container[_kpayment]");
    if (paymentContainer) {
      paymentContainer.remove();
    }
  },
  async completelyRemoveKPayment() {
    return new Promise((resolve, reject) => {
      try {
        console.log("Starting KPayment gateway cleanup...");

        // 1. Remove all script elements
        const scriptElements = document.querySelectorAll('script[src*="kpaymentgateway.kasikornbank.com"]');
        scriptElements.forEach(script => {
          console.log("Removing script:", script.src);
          script.remove();
        });

        // 2. Remove all DOM elements created by KPayment
        const selectors = [
          'div.payment-container[_kpayment]',
          '[_kpayment]', // All elements with _kpayment attribute
          '.payment-container',
          '.pay-button',
          'iframe#kpaymentframe',
          'input[name="token"]',
          'input[name="dcc_currency"]',
          'input[name="saveCard"]',
          'input[name="smartpayId"]',
          'input[name="mid"]',
          'input[name="term"]',
          'input[name="paymentMethods"]',
          'input[name="planid"]',
          'input[name="ipanmode"]',
          'input[name="producttype"]',
          'input[name="supplierno"]',
          'input[name="modelno"]',
          'input[name="chargeId"]',
          'input[name="paymentTimeout"]'
        ];

        selectors.forEach(selector => {
          const elements = document.querySelectorAll(selector);
          console.log(`Removing ${elements.length} elements matching '${selector}'`);
          elements.forEach(el => el.remove());
        });

        // 3. Remove body class that prevents scrolling
        document.body.classList.remove('scroll-y-hidden');

        // 4. Clear the global KPayment object and all references
        if (window.KPayment) {
          // First try to call any cleanup methods KPayment might have
          if (typeof window.KPayment.onClose === 'function') {
            try {
              // The script set a handler for onClose, let's clear it
              window.KPayment.onClose(null);
            } catch (e) {
              console.log("Error clearing KPayment.onClose:", e);
            }
          }

          // Clear all KPayment methods and properties
          const kpaymentProps = Object.getOwnPropertyNames(window.KPayment);
          kpaymentProps.forEach(prop => {
            try {
              window.KPayment[prop] = null;
            } catch (e) {
              console.log(`Error clearing KPayment.${prop}:`, e);
            }
          });

          // Remove the entire KPayment object
          console.log("Removing window.KPayment object");
          window.KPayment = undefined;
          try {
            delete window.KPayment;
          } catch (e) {
            console.log("Error deleting window.KPayment:", e);
          }
        }

        // 5. Clean up event listeners
        if (window.removeEventListener) {
          console.log("Removing payment gateway event listeners");
          // Remove the message event listener that the script sets up
          window.removeEventListener('message', null);
          window.removeEventListener('message', function () {
            // ignore this
          }, false);
        }

        // 6. Clear localStorage and sessionStorage items
        const keysToRemove = [
          "merchanturl", "publicKey", "name", "description", "amount", "currency",
          "paymentMethods", "savecard", "mid", "smartpayId", "term", "customerId",
          "orderId", "refNumber", "campaignId", "planId", "ipanMode", "productType",
          "supplierNo", "modelNo", "lang", "timer", "showButton", "paymentTimeout"
        ];

        keysToRemove.forEach(key => {
          const possibleKeys = [
            key,
            `kpayment_${key}`,
            `kbank_${key}`
          ];

          possibleKeys.forEach(k => {
            if (localStorage.getItem(k)) {
              console.log(`Removing localStorage item: ${k}`);
              localStorage.removeItem(k);
            }
            if (sessionStorage.getItem(k)) {
              console.log(`Removing sessionStorage item: ${k}`);
              sessionStorage.removeItem(k);
            }
          });
        });

        // 7. Clear cookies
        document.cookie.split(';').forEach(cookie => {
          const name = cookie.trim().split('=')[0];
          if (name.match(/k(bank|payment)/i)) {
            console.log(`Removing cookie: ${name}`);
            document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${window.location.hostname}`;
            document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
          }
        });

        // 8. Clear any timeouts set by the script
        if (window.s) {
          console.log("Clearing KPayment timeout");
          clearTimeout(window.s);
          window.s = undefined;
        }

        // 9. Clear internal variables used by the script
        const internalVars = ["p", "s", "d", "l", "m", "y", "f", "h", "b", "v"];
        internalVars.forEach(varName => {
          if (window[varName] !== undefined) {
            console.log(`Clearing potential KPayment internal variable: ${varName}`);
            window[varName] = undefined;
          }
        });

        // 10. Force garbage collection hint
        if (window.gc) {
          try {
            window.gc();
          } catch (e) {
            // Browser doesn't support manual garbage collection
          }
        }

        console.log("KPayment gateway cleanup complete - all traces removed");

        // wait 1 second
        setTimeout(() => {
          console.log("KPayment cleanup timeout complete");
          // Resolve the promise when cleanup is complete
          resolve(true);
        }, 500);
      } catch (e) {
        // Reject the promise in case of any error during the cleanup
        console.error("Error during KPayment cleanup:", e);
        reject(e);
      }
    });
  },
  async processKBankThaiQRPaymentDev(order) {
    try {
      this.paymentLoading = true;

      await this.completelyRemoveKPayment();

      const containerRef = this.$refs["k-payment-form-container"];

      const { paymentId } = await this.createQrPayment("qr");
      const amount = this.order.grandTotal;
      console.log("create qr payment", { paymentId });

      // Create form element
      const form = document.createElement("form");
      form.method = "POST";
      form.action = `https://portal.villamarket.net/thankyou?orderId=${order.orderId}&status=success&amount=${amount}`;

      // Create script element
      const script = document.createElement("script");
      script.type = "text/javascript";
      script.src =
        "https://kpaymentgateway.kasikornbank.com/ui/v2/kpayment.min.js";
      script.setAttribute(
        "data-apikey",
        "pkey_prod_11069UdTmr16AeGHYvqmiD9AFiNJqNLg3lNDT"
      );

      script.setAttribute("data-amount", amount);
      script.setAttribute("data-payment-methods", "qr");
      script.setAttribute(
        "data-order-id",
        paymentId
      );

      // Append script to form
      form.appendChild(script);

      // Append form to container
      containerRef.appendChild(form);

      return new Promise((resolve) => {
        script.onload = async () => {
          console.log("script loaded");
          await window.KPayment.create();
          window.KPayment.show();

          const paymentContainer = document.querySelector("div.payment-container[_kpayment]");
          console.log("paymentContainer class list", paymentContainer.classList);

          const wait = async (ms) => new Promise((r) => setTimeout(r, ms));
          await wait(500);

          // check if class 'show' is not present
          if (paymentContainer && paymentContainer.classList.contains("show")) {
            return resolve();
          }

          await wait(500);

          // check if class 'show' is not present
          if (paymentContainer && !paymentContainer.classList.contains("show")) {
            paymentContainer.classList.add("show");
          }

          resolve();
        };
      });
    } catch (error) {
      console.error("processKBankThaiQRPaymentDev error", error);
      Sentry.captureException(error);
      throw new Error("processKBankThaiQRPaymentDev error");
    } finally {
      this.paymentLoading = false;
    }
  }
};
</script>

<style scoped>
.my-card {
  min-width: 360px;
}

.my-card-mobile {
  width: 100vw;
  height: 100vh;
}

.no-bold {
  font-weight: normal;
}
</style>
